import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import isPropValid from '@emotion/is-prop-valid';
import { TypographyTruncate } from '@infl-ts/ui-advocate-components';
import Photo from '@mui/icons-material/Photo';
import { Box, Card, Link, styled, useMediaQuery } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Content = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: ", ";\n  padding-top: ", ";\n  color: ", ";\n  width: 100%;\n"])), function (p) {
  return p.theme.spacing(2);
}, function (p) {
  return p.theme.spacing(1);
}, function (p) {
  return p.theme.palette.text.primary;
});
var ResizableCard = styled(Card, {
  shouldForwardProp: isPropValid
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  height: ", ";\n  min-width: 192px;\n  width: ", ";\n  margin: 0 auto;\n"])), function (_ref) {
  var canCollapse = _ref.canCollapse;
  return canCollapse ? 'auto' : '288px';
}, function (p) {
  return p.isMobile ? '100%' : p.isTablet ? '384px' : '395px';
});
var NoImage = styled(Photo)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 48px;\n  color: ", ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])), function (p) {
  return p.theme.palette.secondary.dark;
});
var CardImage = styled('img')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 184px;\n  width: 100%;\n  flex-shrink: 0;\n  position: relative;\n  object-fit: contain;\n"])));

var PreviewImage = function PreviewImage(_ref2) {
  var previewImageUrl = _ref2.previewImageUrl,
      previewTitle = _ref2.previewTitle;
  return previewImageUrl && previewImageUrl.length > 0 ? /*#__PURE__*/_jsx(CardImage, {
    src: previewImageUrl,
    alt: previewTitle
  }) : /*#__PURE__*/_jsx(Box, {
    sx: {
      height: 184,
      backgroundColor: function backgroundColor(t) {
        return t.palette.secondary.main;
      },
      position: 'relative'
    },
    children: /*#__PURE__*/_jsx(NoImage, {})
  });
};

var LinkCard = function LinkCard(_ref3) {
  var previewDescription = _ref3.previewDescription,
      previewImageUrl = _ref3.previewImageUrl,
      previewTitle = _ref3.previewTitle,
      _ref3$previewHideImag = _ref3.previewHideImage,
      previewHideImage = _ref3$previewHideImag === void 0 ? false : _ref3$previewHideImag,
      url = _ref3.url,
      onClick = _ref3.onClick;
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  var isTablet = useMediaQuery(function (theme) {
    return theme.breakpoints.down('lg');
  });
  return /*#__PURE__*/_jsx(ResizableCard, {
    isMobile: isMobile,
    isTablet: isTablet,
    canCollapse: previewHideImage,
    "data-element": "ResizableCard",
    "data-component": "LinkCard",
    "data-source-file": "link-card.tsx",
    children: /*#__PURE__*/_jsxs(Link, {
      href: url,
      sx: {
        textDecoration: 'none'
      },
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: onClick,
      "data-element": "Link",
      "data-component": "LinkCard",
      "data-source-file": "link-card.tsx",
      children: [previewHideImage ? null : /*#__PURE__*/_jsx(PreviewImage, {
        previewImageUrl: previewImageUrl,
        previewTitle: previewTitle
      }), /*#__PURE__*/_jsxs(Content, {
        "data-element": "Content",
        "data-component": "LinkCard",
        "data-source-file": "link-card.tsx",
        children: [/*#__PURE__*/_jsx(TypographyTruncate, {
          lines: 2,
          sx: {
            maxHeight: 42
          },
          variant: "h5",
          dangerouslySetInnerHTML: {
            __html: previewTitle
          },
          "data-element": "TypographyTruncate",
          "data-component": "LinkCard",
          "data-source-file": "link-card.tsx"
        }), /*#__PURE__*/_jsx(TypographyTruncate, {
          lines: 1,
          sx: {
            maxHeight: 12,
            mb: 1,
            mt: 1
          },
          variant: "subscript",
          dangerouslySetInnerHTML: {
            __html: previewDescription
          },
          "data-element": "TypographyTruncate",
          "data-source-file": "link-card.tsx"
        }), /*#__PURE__*/_jsx(TypographyTruncate, {
          lines: 1,
          sx: {
            maxHeight: 12
          },
          variant: "subscript",
          color: "textSecondary",
          dangerouslySetInnerHTML: {
            __html: url
          },
          "data-element": "TypographyTruncate",
          "data-source-file": "link-card.tsx"
        })]
      })]
    })
  });
};

export default LinkCard;